const routes = {
  root: '/ppro/details',
}

export default routes
